import { createAuthClient } from "better-auth/react";

/** Better Auth client. Same origin on the web; VITE_API_ORIGIN in the Capacitor shell. */
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_ORIGIN ?? window.location.origin,
});

export const { useSession, signIn, signUp, signOut } = authClient;
